import { createBrowserRouter, RouterProvider } from "react-router-dom";
import HomePage from "./pages/Home/HomePage";
import HistoryPage from "./pages/History/HistoryPage";
import { usePlayerData } from "../hooks/usePlayerData";
import SplashScreen from "./SplashScreen";
import { useDialog } from "../hooks/useDialog";

export default function PageRouter() {
  const { animating, isLoading } = usePlayerData();
  const { dialogs: dialog } = useDialog();
  const router = createBrowserRouter([
    {
      path: "/",
      element: <HomePage />,
    },
    {
      path: "/history",
      element: <HistoryPage />,
    },
    // {
    //     path: '/paper',
    //     element: <WhitePaperPage />,
    // },
  ]);

  return isLoading ? (
    <SplashScreen animating={animating} />
  ) : (
    <div>
      {dialog != undefined && dialog}
      <RouterProvider router={router} />
    </div>
  );
}
